import { render } from "./ModernHome.vue?vue&type=template&id=6294ad2d&scoped=true"
import script from "./ModernHome.vue?vue&type=script&lang=js"
export * from "./ModernHome.vue?vue&type=script&lang=js"

import "./ModernHome.vue?vue&type=style&index=0&id=6294ad2d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6294ad2d"]])

export default __exports__